export default __webpack_public_path__ + "static/media/404.3d0082cc.png";